var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.23 183.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #b3b3b3;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "70.1 38.91 114.22 38.91 92.16 92.16 70.1 38.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "39.02 70.16 39.02 113.9 92.22 91.87 39.02 70.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.63 118.95 157.63 65.12 92.16 92.23 157.63 118.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.75 65.07 65.07 26.75 92.17 92.16 26.75 65.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.98 118.33 66.06 155.18 92.17 92.16 28.98 118.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "113.91 144.57 144.67 113.81 92.17 92.06 113.91 144.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "118.33 155.18 66.12 155.18 92.22 92.16 118.33 155.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "134.6 74.79 92.19 92.36 109.76 49.95 134.6 74.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: ".5 54.19 54.2 .5 92.17 92.16 .5 54.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.17 92.16 54.51 183.06 129.81 183.06 92.17 92.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.62 13.59 124.71 13.6 92.17 92.16 59.62 13.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.63 65.04 92.17 92.16 119.28 26.69 157.63 65.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.73 59.62 92.17 92.16 170.72 124.71 170.73 59.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.7 170.73 170.72 124.71 92.17 92.16 124.7 170.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.59 124.7 59.7 170.53 92.17 92.16 13.59 124.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.59 59.62 13.59 124.7 92.17 92.16 13.59 59.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 92.16,
    cy: 92.16,
    r: 11.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLogo);
export default __webpack_public_path__ + "static/media/animated-logo.ea8c030f45f63cc7e7953b5d2dcd0bef.svg";
export { ForwardRef as ReactComponent };